import React from 'react';
import { Link } from 'react-router-dom';

const SOCIAL_LINKS = [
  {
    href: 'https://www.facebook.com/ifysqld/',
    label: 'IFYS Ltd on Facebook',
    icon: (
      <svg className="w-[18px] h-[18px]" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
  {
    href: 'https://www.instagram.com/ifysqld/?hl=en',
    label: 'IFYS Ltd on Instagram',
    icon: (
      <svg className="w-[18px] h-[18px]" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.077-4.358.2-6.78 2.618-6.98 6.98-.063 1.281-.077 1.689-.077 4.948 0 3.259.014 3.668.077 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.063 1.689.077 4.948.077 3.259 0 3.668-.014 4.948-.077 4.354-.2 6.782-2.618 6.979-6.98.063-1.281.077-1.689.077-4.948 0-3.259-.014-3.667-.077-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.063-1.69-.078-4.949-.078zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
  },
  {
    href: 'https://x.com/ifysltd',
    label: 'IFYS Ltd on X',
    icon: (
      <svg className="w-[16px] h-[16px]" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
  },
  {
    href: 'https://www.youtube.com/channel/UCtUX-UBFCqCYhv5kU7RSiDw',
    label: 'IFYS Ltd on YouTube',
    icon: (
      <svg className="w-[20px] h-[20px]" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
];

const LEGAL_LINKS = [
  {
    label: 'Feedback',
    to: '/contact/contact-ifys',
  },
  {
    label: 'Contact',
    to: '/contact/contact-ifys',
  },
  {
    label: 'Terms of use',
    href: '/documents/IFYS_Website_Terms_and_Conditions.pdf',
  },
  {
    label: 'Privacy',
    href: '/documents/IFYS_Privacy_Policy.pdf',
  },
  {
    label: 'VAD Statement',
    href: '/documents/IFYS_VAD_Statement.pdf',
  },
];

const linkClass =
  'hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-white rounded';

const Footer = () => {
  return (
    <footer className="bg-ifys-blue text-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 w-full min-w-0 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10 md:gap-14 xl:gap-20">
          {/* Left Column - Contact & Links */}
          <div className="space-y-6 min-w-0">
            <div className="space-y-1.5">
              <address className="text-sm not-italic text-white/90">
                IFYS PO Box 1291, Maroochydore QLD 4558
              </address>
              <p className="text-sm">
                <a
                  href="tel:+61754383000"
                  className="hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-white rounded font-semibold"
                >
                  07 5438 3000
                </a>
              </p>
              <p className="text-xs text-white/70 pt-1">
                © {new Date().getFullYear()} IFYS Limited. All rights reserved.
              </p>
            </div>

            {/* Legal / utility links — single line, no wrap */}
            <p className="whitespace-nowrap text-[11px] sm:text-sm text-white/90">
              {LEGAL_LINKS.map((link, i) => (
                <React.Fragment key={link.label}>
                  {i > 0 && <span aria-hidden="true" className="mx-2 text-white/40">|</span>}
                  {link.to ? (
                    <Link to={link.to} className={linkClass}>
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={linkClass}
                    >
                      {link.label}
                    </a>
                  )}
                </React.Fragment>
              ))}
            </p>

            {/* Social Media Icons */}
            <div className="flex items-center gap-2 sm:gap-3">
              {SOCIAL_LINKS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  title={s.label}
                  className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/10 text-white hover:bg-white hover:text-ifys-blue transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-ifys-blue"
                >
                  {s.icon}
                </a>
              ))}
            </div>

            <div>
              <a
                href="/documents/IFYS_Strategic_Plan_2023_2026.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm hover:underline inline-flex items-center gap-1.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-white rounded"
                title="View our strategic plan"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                IFYS Strategic Plan 2023–2026
              </a>
            </div>
          </div>

          {/* Middle Column - Acknowledgment */}
          <div className="space-y-4 min-w-0">
            <h3 className="text-sm font-semibold tracking-[0.18em] uppercase text-white/85">
              Acknowledgment of Country
            </h3>
            <p className="text-sm leading-relaxed text-white/85">
              IFYS acknowledges the Traditional Owners of the Australian land and sea. We pay our
              respects to Elders, past and present. We acknowledge the Traditional Owners&rsquo;
              enduring cultures and traditions, and honour their continuing connection to family,
              country and community.
            </p>
          </div>

          {/* Right Column - Aboriginal Artwork (hidden until xl to prevent overlap) */}
          <div className="hidden xl:block" aria-hidden="true" />
        </div>
      </div>

      {/* Decorative artwork – sits behind on large screens only */}
      <img
        src="/images/image.png"
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="hidden xl:block absolute -right-32 top-1/2 -translate-y-1/2 w-[28rem] h-[28rem] object-cover rounded-full opacity-90 pointer-events-none select-none"
      />
    </footer>
  );
};

export default Footer;
